var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Bank Account' : 'Add Bank Account',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "900px",
      "top": "2vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('copy-from', {
    attrs: {
      "dataForm": _vm.dataForm,
      "options": _vm.bankAccountList,
      "labelFormatter": function labelFormatter(item) {
        return "".concat(item.tag, "-").concat(item.bankName, "(").concat(item.accountNumber, ")");
      }
    },
    on: {
      "copyFromTrigger": _vm.copyFromTrigger
    }
  })], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Supplier",
      "prop": "supplierId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Supplier"
    },
    on: {
      "change": _vm.supplierChange
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: "bank-account-modal-".concat(item.id),
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tag / Label",
      "prop": "tag"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "e.g. DBS SGD, PayNow"
    },
    model: {
      value: _vm.dataForm.tag,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "tag", $$v);
      },
      expression: "dataForm.tag"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Name",
      "prop": "bankName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "e.g. DBS Bank"
    },
    model: {
      value: _vm.dataForm.bankName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "bankName", $$v);
      },
      expression: "dataForm.bankName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Address",
      "prop": "bankAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.bankAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "bankAddress", $$v);
      },
      expression: "dataForm.bankAddress"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Swift Code",
      "prop": "swiftCode"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.swiftCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "swiftCode", $$v);
      },
      expression: "dataForm.swiftCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.payNowLabel,
      "prop": "payNowUen"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.payNowUen,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "payNowUen", $$v);
      },
      expression: "dataForm.payNowUen"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Account Number",
      "prop": "accountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.accountNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "accountNumber", $$v);
      },
      expression: "dataForm.accountNumber"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Currency",
      "prop": "billingCurrency"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Currency"
    },
    model: {
      value: _vm.dataForm.billingCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "billingCurrency", $$v);
      },
      expression: "dataForm.billingCurrency"
    }
  }, _vm._l(_vm.currencyList, function (item) {
    return _c('el-option', {
      key: item.currency,
      attrs: {
        "label": item.currency,
        "value": item.currency
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Account Name",
      "prop": "accountName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.accountName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "accountName", $$v);
      },
      expression: "dataForm.accountName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address of Beneficiary",
      "prop": "addressOfBeneficiary"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.addressOfBeneficiary,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "addressOfBeneficiary", $$v);
      },
      expression: "dataForm.addressOfBeneficiary"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "qrcodeInfoList"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" QR Codes "), _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "content": "PayNow / Other"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('div', {
    staticClass: "uploadWrap"
  }, [_c('div', {
    staticClass: "addUploadBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.addHandle
    }
  }, [_vm._v("Add QR Code")])], 1), _vm._l(_vm.dataForm.qrcodeInfoList, function (item, index) {
    return _c('div', {
      key: "qrcodeInfo-".concat(index),
      staticClass: "wdb100 uploadItem"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('p', {}, [_vm._v("QR Code")]), _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "el-icon-delete",
        "size": "mini",
        "plain": ""
      },
      on: {
        "click": function click($event) {
          return _vm.deleteHandle(index);
        }
      }
    })], 1), _c('div', {
      staticClass: "pb4"
    }, [_c('el-form-item', {
      attrs: {
        "prop": "qrcodeInfoList.".concat(index, ".url"),
        "rules": {
          required: true,
          message: 'please upload',
          trigger: 'submit'
        }
      }
    }, [_c('div', {
      staticClass: "imageUploadBorder"
    }, [_c('el-image-uploader', {
      model: {
        value: _vm.dataForm.qrcodeInfoList[index],
        callback: function callback($$v) {
          _vm.$set(_vm.dataForm.qrcodeInfoList, index, $$v);
        },
        expression: "dataForm.qrcodeInfoList[index]"
      }
    })], 1)])], 1), _c('el-input', {
      attrs: {
        "clearable": "",
        "placeholder": "QR description"
      },
      model: {
        value: _vm.dataForm.qrcodeInfoList[index].remark,
        callback: function callback($$v) {
          _vm.$set(_vm.dataForm.qrcodeInfoList[index], "remark", $$v);
        },
        expression: "dataForm.qrcodeInfoList[index].remark"
      }
    })], 1);
  })], 2)])], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }